import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBpfDcRnJsyghlT0jGvDL596SX8h53gd6A",
  authDomain: "deepnode.in",
  projectId: "knowledgemap-frontend",
  storageBucket: "knowledgemap-frontend.firebasestorage.app",
  messagingSenderId: "1041843059426",
  appId: "1:1041843059426:web:6dfe8a4576fb577c06bcbb",
  measurementId: "G-JSRGQF9L1P",
};
// console.log("Project ID:", process.env.REACT_APP_FIREBASE_PROJECT_ID);

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    // console.log("User signed in:", user);
    return user;
  } catch (error) {
    console.error("Error during Google sign-in:", error);
    throw error;
  }
};


export { app, db, analytics, signInWithGoogle, auth };

